import React, { useContext, useState } from "react";
import { RootStoreContext } from "../../app/stores/rootStore";
import { Form as FinalForm, Field } from "react-final-form";
import { Form, Button, Grid, Segment } from "semantic-ui-react";
import DateInput from "../../app/common/form/DateInput";
import { IFilter } from "../../app/models/trackDocument";
import {
  documentTypesOptions,
  processResultCode,
  emailStateAcquirer
} from "../../app/util/listOfValoursOptions";
import SelectInput from "../../app/common/form/SelectInput";
import { observer } from "mobx-react-lite";
import SelectInputOnSearchChange from "../../app/common/form/SelectInputOnSearchChange";

const FilterForm = () => {
  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const {
    filter,
    setFilter,
    btFilter,
    getAcquirersAutocomplete,
    acquirersAutocomplete,
    dianNumberAutocomplete,
    getDianNumberAutocomplete,
    getDocumentNumberAutocomplete,
    documentNumberAutocomplete,
  } = rootStore.trackDocumentStore;

  const [filterForm] = useState<IFilter>({
    acquirerIdentification: filter.acquirerIdentification,
    documentNumber: filter.documentNumber,
    documentType: filter.documentType,
    dianNumber: filter.dianNumber,
    processState: filter.processState,
    emailStateAcquirer: filter.emailStateAcquirer,
    documentDateFrom: filter.documentDateFrom,
    documentDateTo: filter.documentDateTo,
    receptionDateFrom: filter.receptionDateFrom,
    receptionDateTo: filter.receptionDateTo,
  });

  const handleFinalFormSubmit = (values: any) => {    
    setFilter(values);
  };

  const handleAcquirerIdentification = async (value: any) => {
    getAcquirersAutocomplete(value);
  };

  const handleDocumentNumber = async (value: any) => {
    getDocumentNumberAutocomplete(value);
  };

  const handleDianNumber = async (value: any) => {
    getDianNumberAutocomplete(value);
  };

  return (
    <Segment className="grayborder">
      <FinalForm
        initialValues={filterForm}
        onSubmit={handleFinalFormSubmit}
        render={({ handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <div className="filter">
              <Grid relaxed doubling columns={2}>
                <Grid.Row columns={3}>
                  <Grid.Column>
                    <label>Cliente</label>
                    <Field
                      name="acquirerIdentification"
                      value={filterForm.acquirerIdentification}
                      component={SelectInputOnSearchChange}
                      search={true}
                      autoComplete="off"
                      options={acquirersAutocomplete}
                      onSearchChange={handleAcquirerIdentification}
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <label>Numero Comprobante ERP</label>
                    <Field
                      autoComplete="off"
                      name="documentNumber"
                      value={filterForm.documentNumber}
                      component={SelectInputOnSearchChange}
                      search={true}
                      options={documentNumberAutocomplete}
                      onSearchChange={handleDocumentNumber}
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <label>Numero Comprobante Dian</label>
                    <Field
                      autoComplete="off"
                      name="dianNumber"
                      value={filterForm.dianNumber}
                      component={SelectInputOnSearchChange}
                      search={true}
                      options={dianNumberAutocomplete}
                      onSearchChange={handleDianNumber}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row columns={3}>
                  <Grid.Column>
                    <label>Estado comprobante</label>
                    <Field
                      name="processState"
                      component={SelectInput}
                      search={true}
                      defaultValue={-1}
                      options={processResultCode}
                    />
                  </Grid.Column>

                  <Grid.Column>
                    <label>Estado mail adquiriente</label>
                    <Field
                      name="emailStateAcquirer"
                      component={SelectInput}
                      search={true}
                      defaultValue={-1}
                      options={emailStateAcquirer}
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <label>Tipo de comprobante</label>
                    <Field
                      name="documentType"
                      component={SelectInput}
                      search={true}
                      defaultValue={-1}
                      options={documentTypesOptions}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row columns={3}>
                  <Grid.Column>
                    <label>Fecha comprobante (dd/mm/yyyy)</label>
                    <Form.Group widths="equal">
                      <Field
                        name="documentDateFrom"
                        placeholder="Desde"
                        value={filterForm.documentDateFrom}
                        component={DateInput}
                      />
                      <Field
                        name="documentDateTo"
                        placeholder="Hasta"
                        value={filterForm.documentDateTo}
                        component={DateInput}
                      />
                    </Form.Group>
                  </Grid.Column>
                  <Grid.Column>
                    <label>Fecha recepción (dd/mm/yyyy)</label>
                    <Form.Group widths="equal">
                      <Field
                        name="receptionDateFrom"
                        placeholder="Desde"
                        value={filterForm.receptionDateFrom}
                        component={DateInput}
                      />
                      <Field
                        name="receptionDateTo"
                        placeholder="Hasta"
                        value={filterForm.receptionDateTo}
                        component={DateInput}
                      />
                    </Form.Group>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
              <br />
              <Button
                loading={btFilter}
                disabled={btFilter}
                className="ui primary button filterbutton"
                color="blue"
                type="submit"
                content="Buscar"
              />
            </div>
          </Form>
        )}
      />
    </Segment>
  );
};

export default observer(FilterForm);
